import { DemoComunityListObject } from "pages/files/CommunityListing";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    addSelectedCommunity,
    removeSelectedCommunity
} from "services/redux/feedForm/feedForm";
import { AppDispatch, RootState } from "services/redux/store";
import { SVG } from "ui";
import { CustomComponentProps } from "utils/types/generalTypes";

export type CommunitySelectItemProps = CustomComponentProps & {
    listItem: DemoComunityListObject;
    tempSelectedCommunities: string[];
    toggleSelectedCommunity: (id: string) => void;
};

const CommunitySelectItem = ({
    listItem,
    tempSelectedCommunities,
    toggleSelectedCommunity,
    className,
    style
}: CommunitySelectItemProps) => {
    const [selected, setselected] = useState(false);

    useEffect(() => {
        if (tempSelectedCommunities.indexOf(listItem.id) > -1) {
            setselected(true);
        } else if (selected) {
            setselected(false);
        }
    }, [tempSelectedCommunities]);

    return (
        <div
            className={`card community-list-request d-flex gap-5 flex-j-start flex-a-center w-full ${className}`}
            style={style}
        >
            <div className="text-container d-flex flex-j-start flex-a-center gap-5">
                <div className="community-list-request-img">
                    <img src={listItem.img} alt={listItem.id} />
                </div>
                <div className="text">
                    <h3 className="box-title mb-10">
                        <a href="/communities/@beerexperts">{listItem.title}</a>
                    </h3>
                    <p className="momeento-p">{listItem.about}</p>
                </div>
            </div>
            <div className="community-list-request-btns d-flex flex-j-center flex-a-center gap-5">
                <div
                    className="svg-circle big-circle cursor-pointer"
                    onClick={() => toggleSelectedCommunity(listItem.id)}
                    style={{ width: 32, height: 32 }}
                >
                    {selected && <SVG svg="check" size={18} />}
                </div>
            </div>
        </div>
    );
};

export default CommunitySelectItem;
